__webpack_require__.p = "/FrontEndHomeworkWithAutoCheck/";